import React from 'react';
import WeatherCard from './dashboard/WeatherCard';
import HourlyTemperatureCard from './dashboard/HourlyTemperatureCard';
import WeeklyForecast from './dashboard/WeeklyForecast';
import DashboardSkeleton from './dashboard/DashboardSkeleton';
import { WeatherSideCards } from './dashboard/WeatherSideCards';
import Header from './dashboard/Header';

const Dashboard = ({ weatherData, onSearch, temperatureUnit, onSetTemperatureUnit }) => {
  // Add temperatureUnit to weatherData for components
  const weatherDataWithUnit = { ...weatherData, temperatureUnit };
  // Show empty state if no weather data has been loaded yet or if there's an error
  const hasData = weatherData && weatherData.hasSearched && weatherData.city && !weatherData.error;
  const isLoading = Boolean(weatherData?.isLoading);
  
  if (!hasData && !isLoading) {
    return (
      <div 
        className="flex min-h-screen mx-auto bg-cover bg-center bg-no-repeat bg-fixed"
        style={{ backgroundImage: 'url(/images/layered-peaks-haikei.svg)' }}
      >
        <div className="px-4 flex-1 flex flex-col w-full">
          <Header 
            onSearch={onSearch} 
            city={weatherData?.city} 
            temperatureUnit={temperatureUnit}
            onSetTemperatureUnit={onSetTemperatureUnit}
          />
          <div className="flex-1 p-6 overflow-y-auto">
            <div
              className="py-10 text-center text-gray-100 text-lg"
              role={weatherData?.error ? 'alert' : 'status'}
              aria-live={weatherData?.error ? 'assertive' : 'polite'}
            >
              {weatherData?.error || 'Search for a location above to view weather data'}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="flex min-h-screen mx-auto bg-cover bg-center bg-no-repeat bg-fixed"
      style={{ backgroundImage: 'url(/images/layered-peaks-haikei.svg)' }}
    >
      <div className="flex-1 flex flex-col">
        <Header 
          onSearch={onSearch} 
          city={weatherData.city} 
          temperatureUnit={temperatureUnit}
          onSetTemperatureUnit={onSetTemperatureUnit}
        />
        {isLoading ? (
          <div aria-busy="true" aria-live="polite">
            <span className="sr-only">Loading weather data…</span>
            <div aria-hidden="true">
              <DashboardSkeleton />
            </div>
          </div>
        ) : (
          <div className="flex-1 p-6 overflow-y-auto flex flex-col">
            <div className="flex-1 flex flex-col justify-end min-h-0">
              <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 mb-6">
                <WeatherCard weatherData={weatherDataWithUnit} city={weatherData.city} state={weatherData.state} />
                <WeatherSideCards weatherData={weatherDataWithUnit} />
                <HourlyTemperatureCard weatherData={weatherDataWithUnit} />
              </div>
              <div>
                <WeeklyForecast weatherData={weatherDataWithUnit} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;

